import type { Resource } from '../../';
export const language_de: Resource = {"default":"German"};
